export enum EditorContentAction {
  UpdateCells = 'updateCells',
  UpdateNode = 'updateNode',
}
